import { get } from "helpers/api_helper"

const assignedIds = account => [...new Set((Array.isArray(account.organizerInfo?.assignedClubs)
  ? account.organizerInfo.assignedClubs : []).filter(id => typeof id === "string").map(id => id.trim()))]

export const loadOrganizerClubs = async accounts => {
  const ids = [...new Set(accounts.flatMap(assignedIds))].filter(id => /^[a-f\d]{24}$/i.test(id))
  const ownerIds = accounts.filter(account => account.role === "club" && /^[a-f\d]{24}$/i.test(account.id)).map(account => account.id)
  try {
    const clubs = new Map()
    const deadline = Date.now() + 12000
    for (let start = 0; start < Math.max(ids.length, ownerIds.length); start += 100) {
      const timeout = deadline - Date.now()
      if (timeout <= 0) throw new Error("Clubs lookup timed out")
      const params = new URLSearchParams({ ids: ids.slice(start, start + 100).join(","), ownerIds: ownerIds.slice(start, start + 100).join(",") })
      const response = await get(`/admin/organizers/clubs?${params}`, { timeout })
      if (!Array.isArray(response?.data?.results)) throw new Error("Invalid clubs response")
      response.data.results.forEach(club => clubs.set(String(club.id), club))
    }
    return accounts.map(account => {
      const assigned = assignedIds(account)
      const resolvedClubs = assigned.map(id => clubs.get(id)).filter(Boolean)
      return { ...account, resolvedClubs,
        missingClubCount: assigned.length - resolvedClubs.length,
        ownerClubId: [...clubs.values()].find(club => String(club.ownerId) === account.id)?.id || null,
      }
    })
  } catch (error) {
    return accounts.map(account => ({ ...account, clubsUnavailable: assignedIds(account).length > 0,
      ownerLookupUnavailable: account.role === "club",
      resolvedClubs: [], missingClubCount: 0, ownerClubId: null }))
  }
}
